export default __webpack_public_path__ + "static/media/wTop_1_p2.2c01a154.jpeg";